import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import {authFetch, checkStatus, parseHeadersAndJson} from '../../utils/http';
import {notificationStatus} from '../../utils/constant';
import config from '../../../config';
import {INVITATIONS, INVITATIONS_NOT_DEPOSITOR, NOT_INFORMATIVE_NOTIFICATIONS, NOT_INFORMATIVE_NOTIFICATIONS_NOT_DEPOSITOR} from '../../components/notification/NotificationData';

export default class LiveNotificationService {
  getNewInformationNotifications(organisation, page = 0, size = 1000) {
    // CAREFUL, HERE ARE THE TYPES TO AVOID
    const types = organisation.depositor ?
      NOT_INFORMATIVE_NOTIFICATIONS :
      NOT_INFORMATIVE_NOTIFICATIONS_NOT_DEPOSITOR;
    return this.getPaginatedNewNotifications(organisation.organisationId, types, page, size);
  }

  getNewActionsNotifications(organisation) {
    // CAREFUL, HERE ARE THE TYPES TO GET
    const types = organisation.depositor ?
      INVITATIONS :
      INVITATIONS_NOT_DEPOSITOR;
    return this.getNewNotifications(organisation.organisationId, types);
  }

  getNewNotifications(organisationId, notificationTypesToGet = []) {
    let url = `${config.notificationApi}/api/v1/in-app-notifications?organisationId=${organisationId}&status=NEW`;
    if (!isEmpty(notificationTypesToGet)) {
      url += `&inAppNotificationTypes=${notificationTypesToGet.join(',')}`;
    }

    return authFetch(url)
      .then(checkStatus)
      .then(response => response.json());
  }

  getPaginatedNewNotifications(organisationId, notificationTypesToAvoid = [], page = 0, size = 100) {
    let url = `${config.notificationApi}/api/v1/in-app-notifications?organisationId=${organisationId}&status=NEW&page=${page}&size=${size}`;
    if (!isEmpty(notificationTypesToAvoid)) {
      url += `&inAppNotificationTypes=${notificationTypesToAvoid.join(',')}`;
    }

    return authFetch(url)
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        notifications: json,
        totalCount: Number(headers.get('X-Total-Count')),
        numberOfNewNotifications: json.filter(notification => !notification.viewed).length
      }));
  }

  dismiss(notificationId) {
    const data = {
      status: notificationStatus.DISMISSED
    };
    return authFetch(`${config.notificationApi}/api/v1/in-app-notifications/${notificationId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(checkStatus);
  }

  updateLastSeenNotifications(organisationId) {
    return authFetch(`${config.notificationApi}/api/v1/in-app-notifications/${organisationId}/last-view-date`, {
      method: 'PATCH'
    })
      .then(checkStatus);
  }

  updateNotificationByUploadingFile(notificationId, file) {
    const formData = new FormData();
    formData.append('file', file);

    return authFetch(`${config.notificationApi}/api/v1/in-app-notifications/${notificationId}`, {
      method: 'POST',
      body: formData
    }).then(checkStatus);
  }
}
